let DataProp = document.querySelector('#Prop');
let data = JSON.parse(DataProp?.getAttribute('data-data') ?? '{}');
let api = DataProp?.getAttribute('data-api') ?? '';
let banner = DataProp?.getAttribute('data-banner') ?? '';
let title = DataProp?.getAttribute('data-title') ?? '';
let formaction = DataProp?.getAttribute('data-formaction') ?? '';
let recapchakey = DataProp?.getAttribute('data-recapchakey') ?? '';
let verification = DataProp?.getAttribute('data-verification') ?? '';

var information = {
	data,
	api,
	banner,
	title,
	formaction,
	recapchakey,
	verification
};

export default information;